"use strict";

angular.module("app.elements.visual-cta-also-interesting", [])
  .directive("viVisualCtaAlsoInteresting", function () {
    return {
      templateUrl: "app/js/modules/elements/visual-cta-also-interesting/visual-cta-also-interesting.html"
    };
  });
